import YourAmbassadors from "@/components/Common/referral/YourAmbassadors";
import {settingsModalAtom} from "@/store/jotaiAtoms";
import type {TSettingsScope} from "@/store/types";
import {useSetAtom} from "jotai";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const AmbassadorsPane: FC<{scope: TSettingsScope}> = ({scope}) => {
  const {t} = useTranslation("settings");
  const setSettingsModal = useSetAtom(settingsModalAtom);
  const isAgency = scope.type === "agency";

  return (
    <div className="flex flex-col gap-8">
      <span className="text-neutral-black text-lg leading-none font-bold">{t("ambassadors")}</span>
      <YourAmbassadors
        agencyId={isAgency ? scope.id : null}
        companyId={isAgency ? null : scope.id}
        onOpenProgram={() => setSettingsModal(state => state && {...state, subview: {type: "ambassador_program"}})}
      />
    </div>
  );
};

export default AmbassadorsPane;
